import _objectWithoutProperties from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children", "dimension", "getDimensionValue"];

var _collapseStyles;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import css from 'dom-helpers/css';
import React, { useMemo } from 'react';
import { ENTERED, ENTERING, EXITED, EXITING } from 'react-transition-group/Transition';
import transitionEndListener from './transitionEndListener';
import createChainedFunction from './createChainedFunction';
import triggerBrowserReflow from './triggerBrowserReflow';
import TransitionWrapper from './TransitionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

function getDefaultDimensionValue(dimension, elem) {
  var offset = "offset".concat(dimension[0].toUpperCase()).concat(dimension.slice(1));
  var value = elem[offset];
  var margins = MARGINS[dimension];
  return value + // @ts-ignore
  parseInt(css(elem, margins[0]), 10) + // @ts-ignore
  parseInt(css(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _defineProperty(_collapseStyles, EXITED, 'collapse'), _defineProperty(_collapseStyles, EXITING, 'collapsing'), _defineProperty(_collapseStyles, ENTERING, 'collapsing'), _defineProperty(_collapseStyles, ENTERED, 'collapse show'), _collapseStyles);
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  getDimensionValue: getDefaultDimensionValue
};
var Collapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      className = _ref.className,
      _children = _ref.children,
      _ref$dimension = _ref.dimension,
      dimension = _ref$dimension === void 0 ? 'height' : _ref$dimension,
      _ref$getDimensionValu = _ref.getDimensionValue,
      getDimensionValue = _ref$getDimensionValu === void 0 ? getDefaultDimensionValue : _ref$getDimensionValu,
      props = _objectWithoutProperties(_ref, _excluded);

  /* Compute dimension */
  var computedDimension = typeof dimension === 'function' ? dimension() : dimension;
  /* -- Expanding -- */

  var handleEnter = useMemo(function () {
    return createChainedFunction(function (elem) {
      elem.style[computedDimension] = '0';
    }, onEnter);
  }, [computedDimension, onEnter]);
  var handleEntering = useMemo(function () {
    return createChainedFunction(function (elem) {
      var scroll = "scroll".concat(computedDimension[0].toUpperCase()).concat(computedDimension.slice(1));
      elem.style[computedDimension] = "".concat(elem[scroll], "px");
    }, onEntering);
  }, [computedDimension, onEntering]);
  var handleEntered = useMemo(function () {
    return createChainedFunction(function (elem) {
      elem.style[computedDimension] = null;
    }, onEntered);
  }, [computedDimension, onEntered]);
  /* -- Collapsing -- */

  var handleExit = useMemo(function () {
    return createChainedFunction(function (elem) {
      elem.style[computedDimension] = "".concat(getDimensionValue(computedDimension, elem), "px");
      triggerBrowserReflow(elem);
    }, onExit);
  }, [onExit, getDimensionValue, computedDimension]);
  var handleExiting = useMemo(function () {
    return createChainedFunction(function (elem) {
      elem.style[computedDimension] = null;
    }, onExiting);
  }, [computedDimension, onExiting]);
  return /*#__PURE__*/_jsx(TransitionWrapper, _objectSpread(_objectSpread({
    ref: ref,
    addEndListener: transitionEndListener
  }, props), {}, {
    "aria-expanded": props.role ? props.in : null,
    onEnter: handleEnter,
    onEntering: handleEntering,
    onEntered: handleEntered,
    onExit: handleExit,
    onExiting: handleExiting,
    childRef: _children.ref,
    children: function children(state, innerProps) {
      return /*#__PURE__*/React.cloneElement(_children, _objectSpread(_objectSpread({}, innerProps), {}, {
        className: classNames(className, _children.props.className, collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
      }));
    }
  }));
}); // @ts-ignore
// @ts-ignore

Collapse.defaultProps = defaultProps;
export default Collapse;